import { Routes } from '@angular/router';
import { applicationSubmitGuard } from '@pkp/core';

export const MOBILE_ABOUT_BENEFITS_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    data: { hideNavBar: true },
    loadComponent: () =>
      import('./pages/benefits-page/benefits-page.component').then(c => c.BenefitsPageComponent),
  },
  {
    path: 'benefits-order',
    data: { hideNavBar: true },
    canActivate: [applicationSubmitGuard],
    loadComponent: () =>
      import('./pages/benefits-order/benefits-order.component').then(
        c => c.AboutBenefitsOrderComponent,
      ),
  },
];
